import moment from 'moment-timezone';

angular.module('ResearchKitApplicationModule').factory('dateUtility', [function () {

	var dateIsValid = function (dateString) {
		return moment(dateString, 'YYYY-MM-DD[T]HH:mm:ss', true).isValid();
	}

	var relativeDateIsValid = function (relativeDateObject) {
		return (relativeDateObject && relativeDateObject.type === 'RelativeDate');
	}

	var specificMomentFromRelativeDateObject = function (relativeDateObject) {
		if (relativeDateIsValid(relativeDateObject)) {
			let theDate = relativeDateObject.fromStartOfDay === "true" ? moment().startOf('day') : moment();

			if (relativeDateObject.offsetYears !== 0) {
				theDate = theDate.add(relativeDateObject.offsetYears, 'years');
			} else if (relativeDateObject.offsetMonths !== 0) {
				theDate = theDate.add(relativeDateObject.offsetMonths, 'months');
			} else if (relativeDateObject.offsetWeeks !== 0) {
				theDate = theDate.add(relativeDateObject.offsetWeeks, 'weeks');
			} else if (relativeDateObject.offsetDays !== 0) {
				theDate = theDate.add(relativeDateObject.offsetDays, 'days');
			} else if (relativeDateObject.offsetHours !== 0) {
				theDate = theDate.add(relativeDateObject.offsetHours, 'hours');
			} else if (relativeDateObject.offsetMinutes !== 0) {
				theDate = theDate.add(relativeDateObject.offsetMinutes, 'minutes');
			}

			return theDate;
		}
		return undefined;
	}

	var specificMomentFromRelativeDateSelectorModel = function (relativeDateModel) {
		var calculated = null;
		if (!relativeDateModel.FromStartOfDay) {
			calculated = moment().add(relativeDateModel.ValueOffset * relativeDateModel.OffsetModifier, relativeDateModel.OffsetUnits);
		}
		else {
			calculated = moment();
			if (relativeDateModel.TimeZoneId) {
				var timeZoneObj = _.findWhere(relativeDateModel.timeZones, { Id: relativeDateModel.TimeZoneId });
				if (timeZoneObj && timeZoneObj.IanaTZ) {
					calculated = moment().tz(timeZoneObj.IanaTZ).add(relativeDateModel.ValueOffset * relativeDateModel.OffsetModifier, relativeDateModel.OffsetUnits);
				}
				else {
					return;
				}
			}
			calculated.set({ 'hour': 0, 'minute': 0, 'second': 0 });
			calculated = calculated.add(relativeDateModel.ValueOffset * relativeDateModel.OffsetModifier, relativeDateModel.OffsetUnits);
		}
		return calculated;
	}

	var momentFromDateObjectOrString = function (dateObjOrString) {
		if (dateObjOrString) {
			if (dateObjOrString.type && dateObjOrString.type === 'RelativeDate') {
				return specificMomentFromRelativeDateObject(dateObjOrString);
			} else {
				return moment(dateObjOrString);
			}
		}
	}

	var momentFromDateSelectorModel = function (dateModel) {
		if (!dateModel) return undefined;
		if (dateModel.Type && dateModel.Type === 'Relative') {
			if (dateModel.ValueOffset != undefined)
				return specificMomentFromRelativeDateSelectorModel(dateModel);
		} else if (dateModel.Type && dateModel.Type === 'Absolute') {
			return moment(dateModel.DateValue);
		}
	}

	var momentFromTimeSelectorModel = function (timeModel) {
		if (timeModel.Type && timeModel.Type === 'Absolute') {
			return moment(timeModel.Hour + ":" + timeModel.Minute + " " + timeModel.Period);
		}
	}

	var dateFromDateObjectOrString = function (dateObjString) {
		let theMoment = momentFromDateObjectOrString(dateObjString);
		if (theMoment) return theMoment.toDate();
		else return undefined;
	}

	return {
		dateIsValid: dateIsValid,
		relativeDateIsValid: relativeDateIsValid,
		dateFromDateObjectOrString: dateFromDateObjectOrString,
		momentFromDateObjectOrString: momentFromDateObjectOrString,
		momentFromDateSelectorModel: momentFromDateSelectorModel,
		momentFromTimeSelectorModel: momentFromTimeSelectorModel
	};
}])